"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTKey = void 0;
var localKeys = {
  noItems: 'noItems',
  btnHeaderAdd: 'Add',
  btnHeaderEdit: 'Edit',
  btnHeaderDownload: 'Download',
  btnHeaderUpload: 'Upload',
  searchPlaceholder: 'Search',
  searchResult: 'searchResult',
  filterFieldsPlaceholder: 'Select',
  btnFooterCancel: 'Cancel',
  btnFooterSelect: 'Select',
  "export": 'Export',
  csv: 'CSV',
  excel: 'Excel',
  totalResults: 'totalResults',
  paginationOf: 'of',
  paginationTotal: 'Total'
};

var getTKey = function getTKey(tKeys, key) {
  return tKeys && tKeys[key] || localKeys[key];
};

exports.getTKey = getTKey;